
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import _ from 'lodash';

@Component
export default class Login extends Vue {
  @Action('user/login') login!: Function;
  @Action('notifications/addNotification') addNotification!: Function;
  @Getter('user/authenticated') authenticated!: boolean;

  email = null;
  password = null;
  hidePassword: boolean = true;
  emailRules = [
    (v: any) => !!v || 'E-mail is required',
    (v: any) => /^[^@]+@[^@]+\.[^@]+$/.test(v) || 'E-mail must be valid',
  ];

  userLogin() {
    this.login({ email: this.email, password: this.password }).then(() => {
      if (_.isUndefined(this.authenticated)) {
        this.addNotification({
          text: 'Login error! Please try again',
          colour: 'red',
          top: true,
          right: true,
        });
      }
    });
  }

  @Watch('authenticated', { immediate: true, deep: true })
  onAuthenticatedChanged() {
    if (this.authenticated === true) {
      this.addNotification({
        text: 'Login successful! Redirecting now...',
        colour: 'green',
        top: true,
        right: true,
      });
      if (_.has(this.$router.currentRoute.query, 'redirect')) {
        this.$router.push(`${this.$router.currentRoute.query.redirect}`);
      } else {
        this.$router.push('/content');
      }
    } else if (this.authenticated === false) {
      this.addNotification({
        text: 'You do not have permissions to access the CMS',
        colour: 'red',
        top: true,
        right: true,
      });
    }
  }
}
